import { useModuleGateForWorkspace } from '../lib/moduleGate';

/**
 * True when the canonical commitment view is on for the workspace that owns
 * the record being rendered.
 *
 * Canonical gate (§2.7): `commitment_view` workspace module + flag, resolved
 * against the RECORD's workspace rather than the session's. Plan-of-record
 * surfaces are reachable by URL and can belong to a workspace other than the
 * active one — the 2026-08-21 defect that `useModuleGateForWorkspace` exists to
 * fix. Pass the plan cycle's workspace id; the hook falls back to the
 * current-workspace resolution while it is still loading.
 *
 * Read-only surface, so nothing is gated server-side: there is nothing to gate.
 */
export function useCommitmentViewEnabled(workspaceId: string | null | undefined): boolean {
  return useModuleGateForWorkspace(workspaceId, 'commitment_view');
}
